import actionTypes from 'SRC/modules/redux/actionTypes'

export const setVehiclePart = part => ({
  type: actionTypes.SET_VEHICLE_PARTS_ITEM,
  payload: part
})
